module.exports = __webpack_public_path__ + "231f089543fe470aecac021d5dfbaae7.fbx";